import { forwardRef, useContext, useEffect, useState } from "react";
import _ from "lodash";
import { TreeContext } from "pages/Editor";
import { useAttribute } from "lib/hooks/hooks";

function Heading({ component, path, style }, ref) {
  const { update, editable } = useContext(TreeContext);
  const [editing, setEditing] = useState(false);
  const onDoubleClick = () => setEditing(true);
  const [type] = useAttribute("type", false);
  const { value, name } = component;
  const onKeyDown = ({ keyCode, target }) => {
    if (keyCode === 13) {
      update(path + ".value", target.innerText);
      setEditing(false);
    }
  };
  useEffect(() => {
    if (editing) {
      ref.current.focus();
      document.execCommand("selectAll");
    }
  }, [editing, ref]);
  useEffect(() => {
    if (_.get(ref, "current")) ref.current.innerText = value || name;
  }, [name, ref, value]);
  const heading = { type };
  if (!type) heading.type = "h1";
  if (!editable)
    return <heading.type {...{ style }}>{value || name}</heading.type>;
  return (
    <heading.type
      {...{ ref, onDoubleClick, style, onKeyDown, contentEditable: editing }}
    />
  );
}

export default forwardRef(Heading);
